import { render, staticRenderFns } from "./ReportTabGeneral.vue?vue&type=template&id=12ba9924&scoped=true&lang=pug"
import script from "./ReportTabGeneral.vue?vue&type=script&lang=js"
export * from "./ReportTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./ReportTabGeneral.vue?vue&type=style&index=0&id=12ba9924&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba9924",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12ba9924')) {
      api.createRecord('12ba9924', component.options)
    } else {
      api.reload('12ba9924', component.options)
    }
    module.hot.accept("./ReportTabGeneral.vue?vue&type=template&id=12ba9924&scoped=true&lang=pug", function () {
      api.rerender('12ba9924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/report/ReportTabGeneral.vue"
export default component.exports